export function createWorkoutCoachRefreshScheduler({
  scheduleTimer = (callback, delay) => setTimeout(callback, delay),
  cancelTimer = handle => clearTimeout(handle),
} = {}) {
  const pending = new Map();

  const cancel = scopeId => {
    const key = String(scopeId || '');
    if (!pending.has(key)) return false;
    cancelTimer(pending.get(key));
    pending.delete(key);
    return true;
  };

  return {
    schedule(scopeId, callback, delay) {
      const key = String(scopeId || '');
      if (!key || typeof callback !== 'function') return null;
      cancel(key);
      const handle = scheduleTimer(() => {
        pending.delete(key);
        callback();
      }, delay);
      pending.set(key, handle);
      return handle;
    },
    cancel,
    hasPending(scopeId) {
      return pending.has(String(scopeId || ''));
    },
    dispose() {
      for (const handle of pending.values()) cancelTimer(handle);
      pending.clear();
    },
  };
}
